import React from "react";

interface InfoMessageNoteProps {
  display: any;
  className?: string;
}

const InfoMessageNote: React.FC<InfoMessageNoteProps> = ({ display, className="" }) => {
     return (
         <div
             className={`p-2 border border-l-4 border-figmaColors-ActiveBlueInteraction text-figmaColors-ActiveBlueInteraction rounded mt-4 mb-4 ${className}`}
         >{display}</div>
  );
}
export default InfoMessageNote;